import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { useTranslation } from "react-i18next";

const primaryColor = "#43BD98";

const HowItWorks = () => {
	const { t } = useTranslation();
	const sectionRef = useRef(null);
	const isInView = useInView(sectionRef, { once: true, margin: "-100px" });

	const steps = t("store.howItWorks.steps", { returnObjects: true });

	return (
		<section
			ref={sectionRef}
			style={{
				padding: "6rem 2rem",
				backgroundColor: "#ffffff",
				fontFamily: "'Poppins', sans-serif",
			}}
		>
			{/* Título */}
			<motion.div
				style={{ textAlign: "center", marginBottom: "3rem" }}
				initial={{ opacity: 0, y: 20 }}
				animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
				transition={{ duration: 0.7, ease: "easeOut" }}
			>
				<p
					style={{
						color: primaryColor,
						fontSize: "0.9rem",
						fontWeight: 600,
						letterSpacing: "1px",
						textTransform: "uppercase",
						marginBottom: "0.5rem",
					}}
				>
					{t("store.howItWorks.badge")}
				</p>
				<h2
					style={{
						fontSize: "clamp(1.8rem, 5vw, 2.6rem)",
						color: "#1a1a1a",
						fontWeight: 800,
						margin: 0,
					}}
				>
					{t("store.howItWorks.title")}
				</h2>
			</motion.div>

			{/* Steps */}
			<div
				style={{
					display: "flex",
					flexWrap: "wrap",
					justifyContent: "center",
					gap: "2rem",
				}}
			>
				{steps.map((step, i) => (
					<motion.div
						key={i}
						initial={{ opacity: 0, y: 25, scale: 0.98 }}
						animate={
							isInView
								? { opacity: 1, y: 0, scale: 1 }
								: { opacity: 0, y: 25, scale: 0.98 }
						}
						transition={{
							duration: 0.6,
							delay: i * 0.15,
							ease: [0.25, 0.1, 0.25, 1],
						}}
						className="step-card"
						style={{
							flex: "1 1 240px",
							maxWidth: "260px",
							backgroundColor: "#f8fefc",
							border: `1px solid ${primaryColor}`,
							borderRadius: "18px",
							padding: "2.4rem 1.8rem",
							textAlign: "center",
							boxShadow: "0 8px 24px rgba(0,0,0,0.03)",
						}}
					>
						<div
							style={{
								width: "56px",
								height: "56px",
								borderRadius: "50%",
								backgroundColor: primaryColor,
								color: "#fff",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								fontWeight: 700,
								fontSize: "1.2rem",
								margin: "0 auto 1.2rem auto",
								boxShadow: "0 4px 12px rgba(67,189,152,0.3)",
							}}
						>
							{i + 1}
						</div>
						<h3
							style={{
								fontSize: "1.1rem",
								fontWeight: 600,
								color: "#222",
								marginBottom: "0.6rem",
							}}
						>
							{step.title}
						</h3>
						<p
							style={{
								color: "#555",
								fontSize: "0.95rem",
								lineHeight: 1.6,
							}}
						>
							{step.description}
						</p>
					</motion.div>
				))}
			</div>

			<style>{`
				.step-card {
					transition: transform 0.25s ease, box-shadow 0.25s ease;
				}
				.step-card:hover {
					transform: translateY(-6px) scale(1.02);
					box-shadow: 0 10px 25px rgba(67,189,152,0.15);
				}
				@media (max-width: 640px) {
					.step-card {
						flex: 1 1 auto !important;
						max-width: 100% !important;
						width: auto !important;
					}
				}
			`}</style>
		</section>
	);
};

export default HowItWorks;
